import { History } from "history";

import {
  ADD_CALENDAR_EVENT,
  ADD_CALENDAR_EVENT_ERROR,
  ADD_CALENDAR_EVENT_SUCCESS,
  AddCalendarEventAction,
  AddCalendarEventErrorAction,
  AddCalendarEventSuccessAction,
  DELETE_CALENDAR_EVENT,
  DELETE_CALENDAR_EVENT_CONSENT,
  DELETE_CALENDAR_EVENT_ERROR,
  DELETE_CALENDAR_EVENT_SUCCESS,
  DeleteCalendarEventAction,
  DeleteCalendarEventConsentAction,
  DeleteCalendarEventErrorAction,
  DeleteCalendarEventSuccessAction,
  GET_ALL_CALENDAR_EVENTS,
  GET_ALL_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENT,
  GET_CALENDAR_EVENTS,
  GET_CALENDAR_EVENTS_ERROR,
  GET_CALENDAR_EVENTS_SUCCESS,
  GET_CALENDAR_EVENT_ERROR,
  GET_CALENDAR_EVENT_SUCCESS,
  GetAllCalendarEventsAction,
  GetAllCalendarEventsErrorAction,
  GetAllCalendarEventsSuccessAction,
  GetCalendarEventAction,
  GetCalendarEventErrorAction,
  GetCalendarEventSuccessAction,
  GetCalendarEventsAction,
  GetCalendarEventsErrorAction,
  GetCalendarEventsSuccessAction,
  UPDATE_CALENDAR_EVENT,
  UPDATE_CALENDAR_EVENT_ERROR,
  UPDATE_CALENDAR_EVENT_SUCCESS,
  UpdateCalendarEventAction,
  UpdateCalendarEventErrorAction,
  UpdateCalendarEventSuccessAction,
} from "./actionTypes";
import {
  CreateCalendarEventRequest,
  CalendarEventDto,
  PaginateQuery,
  UpdateCalendarEventRequest,
} from "../../interfaces";
import { Paginated } from "../../models";

//#region Get Calendar Events

export const getCalendarEvents = (
  request: PaginateQuery,
  history: History
): GetCalendarEventsAction => {
  return {
    type: GET_CALENDAR_EVENTS,
    payload: { request, history },
  };
};

export const getCalendarEventsSuccess = (
  response: Paginated<CalendarEventDto>
): GetCalendarEventsSuccessAction => {
  return {
    type: GET_CALENDAR_EVENTS_SUCCESS,
    payload: response,
  };
};

export const getCalendarEventsError = (
  error: any
): GetCalendarEventsErrorAction => {
  return {
    type: GET_CALENDAR_EVENTS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get All Calendar Events

export const getAllCalendarEvents = (
  history: History
): GetAllCalendarEventsAction => {
  return {
    type: GET_ALL_CALENDAR_EVENTS,
    payload: { history },
  };
};

export const getAllCalendarEventsSuccess = (
  response: CalendarEventDto[]
): GetAllCalendarEventsSuccessAction => {
  return {
    type: GET_ALL_CALENDAR_EVENTS_SUCCESS,
    payload: response,
  };
};

export const getAllCalendarEventsError = (
  error: any
): GetAllCalendarEventsErrorAction => {
  return {
    type: GET_CALENDAR_EVENTS_ERROR,
    payload: error,
  };
};

//#endregion

//#region Get Calendar Event

export const getCalendarEvent = (
  id: string,
  history: History
): GetCalendarEventAction => {
  return {
    type: GET_CALENDAR_EVENT,
    payload: { id, history },
  };
};

export const getCalendarEventSuccess = (
  response: CalendarEventDto
): GetCalendarEventSuccessAction => {
  return {
    type: GET_CALENDAR_EVENT_SUCCESS,
    payload: response,
  };
};

export const getCalendarEventError = (
  error: any
): GetCalendarEventErrorAction => {
  return {
    type: GET_CALENDAR_EVENT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Add Calendar Event

export const addCalendarEvent = (
  request: CreateCalendarEventRequest,
  history: History
): AddCalendarEventAction => {
  return {
    type: ADD_CALENDAR_EVENT,
    payload: { request, history },
  };
};

export const addCalendarEventSuccess = (
  createdEvent: CalendarEventDto
): AddCalendarEventSuccessAction => {
  return {
    type: ADD_CALENDAR_EVENT_SUCCESS,
    payload: createdEvent,
  };
};

export const addCalendarEventError = (
  error: any
): AddCalendarEventErrorAction => {
  return {
    type: ADD_CALENDAR_EVENT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Update Calendar Event

export const updateCalendarEvent = (
  id: string,
  request: UpdateCalendarEventRequest,
  history: History
): UpdateCalendarEventAction => {
  return {
    type: UPDATE_CALENDAR_EVENT,
    payload: { id, request, history },
  };
};

export const updateCalendarEventSuccess = (
  updatedEvent: CalendarEventDto
): UpdateCalendarEventSuccessAction => {
  return {
    type: UPDATE_CALENDAR_EVENT_SUCCESS,
    payload: updatedEvent,
  };
};

export const updateCalendarEventError = (
  error: any
): UpdateCalendarEventErrorAction => {
  return {
    type: UPDATE_CALENDAR_EVENT_ERROR,
    payload: error,
  };
};

//#endregion

//#region Delete Calendar Event

export const deleteCalendarEventConsent = (
  id: string
): DeleteCalendarEventConsentAction => {
  return {
    type: DELETE_CALENDAR_EVENT_CONSENT,
    payload: id,
  };
};

export const deleteCalendarEvent = (
  id: string,
  history: History
): DeleteCalendarEventAction => {
  return {
    type: DELETE_CALENDAR_EVENT,
    payload: { id, history },
  };
};

export const deleteCalendarEventSuccess = (
  deleteItemId: string
): DeleteCalendarEventSuccessAction => {
  return {
    type: DELETE_CALENDAR_EVENT_SUCCESS,
    payload: deleteItemId,
  };
};

export const deleteCalendarEventError = (
  error: any
): DeleteCalendarEventErrorAction => {
  return {
    type: DELETE_CALENDAR_EVENT_ERROR,
    payload: error,
  };
};

//#endregion
